var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 6.85454L17.1421 11.0972L7.24264 20.9967H3V16.754L12.8995 6.85454ZM14.3137 5.44033L16.435 3.31901C16.8256 2.92849 17.4587 2.92849 17.8492 3.31901L20.6777 6.14744C21.0682 6.53796 21.0682 7.17113 20.6777 7.56165L18.5563 9.68297L14.3137 5.44033Z",
    fill: "#F43D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRed);
export default __webpack_public_path__ + "static/media/editRed.38487ff50502a5ffcf6e3bd6ceda2663.svg";
export { ForwardRef as ReactComponent };